import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';
import ExportBox from "../components/ExportBox/ExportBox"
import Table from "../components/Table/Table"
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function Settings() {
      const userinfo = useSelector((state) => state);
      const navigate = useNavigate();

          const { currentLocal } = useSelector((state) => state.currentLocal);
              const [items, setItems] = useState([])
                useEffect(() => {
        const getAllApis = async () => {


            await axios
              .get(`https://nanosoft.space/taarteb/public/api/admin/employees`, {
                    headers: {
                        Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                    }
                })
                .then(async (res) => {
                //   console.log(res.data.data);
                  
  //         const nameMap = {
  //   "Financial Director": currentLocal.home.Financialofficer,
  //   "Sales Employee":currentLocal.home.salesemployee,
  //   "Purchasing Employee": currentLocal.home.Purchasingemployee,
  //   "Salaries Employee": currentLocal.home.Salariesemployee,
  //   "Maintenance Employee":currentLocal.home.Maintenanceemployee,
  //               "Other": currentLocal.home.Other,

  // };
  //                     const translatedEmployees = res.data.data.data.map((emp) => ({
  //   ...emp,
  //   role: nameMap[emp.role] || emp.role, // translate main role
  //   roles: emp.roles.map((r) => ({
  //     ...r,
  //     name: nameMap[r.name] || r.name, // translate nested role
  //   })),
  // }));
setItems(res.data.data.data)

                })
                .catch((error) => {


                });



    
  

        }
        getAllApis()

    }, [])

    const headerIterm = [
        currentLocal.home.ID,
        currentLocal.home.namePlaceholder,
        currentLocal.home.emailPlaceholder,
        currentLocal.home.phone,
        // currentLocal.home.permissions,
        "",

   ]

  const body = <tbody>
    {items?.map((item, index) => {

      return (
        <tr key={index}>
<td>
  {item?.id}
</td>
<td>
  {item?.name}
</td>
<td>
  {item?.email}
</td>
<td>
  {item?.phone}
</td>
<td>
        <button
                    className='bg-transparent mx-2 border-info p-1 rounded'
                    onClick={() => navigate(`/dashboard/edite-employe/${ item?.id}`)}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="rgba(13,202,240)" className="bi bi-pencil-square" viewBox="0 0 16 16">
                      <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                      <path fillRule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                    </svg>
                  </button>
</td>





        </tr>
      )
    })}

  </tbody>   
   
  return (
    <div className="px-0 my-3 w-100 dashboard_content">
    <Container>
        <div className="d-flex flex-column w-100">
            
            <AuthNavbar />
            <div className="mt-5 mx-3">
                <HomeTitle title={currentLocal.home.permissions} />
                <ExportBox
                                   title={""}
                    paragrapg={' '}
                    addingBtn={currentLocal.home.addEmploye}
                    exportState={false}
                />

                <Table
                    data={items}
                    headerIterm={headerIterm}
                    actions={["edit"]}
                    body={body}
                    // onDataChanged={getAllApis}
                />


            </div>

        </div>
    </Container>
</div>)
}

export default Settings